module.exports = __webpack_public_path__ + "static/media/thibault-penin-767722-unsplash.1b9c495c.jpg";